var map = {
	"./legend_xg_dark_vertical.png": "Uen6",
	"./legend_xg_english_dark_vertical.png": "cKRc",
	"./legend_xg_english_vertical.png": "6yIz",
	"./legend_xg_spanish_dark_vertical.png": "gOS5",
	"./legend_xg_spanish_vertical.png": "bTCJ",
	"./legend_xg_vertical.png": "AzRh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "j5EO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/legend_xg.*_vertical\.png$
// module id = j5EO
// module chunks = 94